import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

export default defineNuxtPlugin(() => {
  dayjs.extend(utc)
  dayjs.extend(timezone)
})
